export default (params) => ({
  trigger: {
    name: 'content_blocks.inspiration.select_product_information',
    params: params,
  },
  config: {
    schema: {
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
        content: 'product_information',
      },
    },
  },
});
